import { call, put, takeEvery } from "redux-saga/effects";
import { fetch_campaign_details } from "../../apis/ordersAuth";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";
import { fetchOrderData, setOrderData } from "../reducers/ordersAuth";

export default function* handleOrdersAuthSaga() {
  yield takeEvery(fetchOrderData.toString(), handleFetchOrderData);
}

function* handleFetchOrderData({ payload }){
  const { Api, urlSafeKey, screen } = payload;
  try {
    yield put(setLoader({screen, isPageLoading: true}));
    yield put(setError({screen, isFetchFailed : false}));
    const result = yield call(fetch_campaign_details, Api, urlSafeKey)
    yield put(setOrderData(result));
  } catch (error) {
    yield put(setError({screen, isFetchFailed : true}));
  } finally{
    yield put(setLoader({screen, isPageLoading: false}));
  }
}
